import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "errorModal" }
const _hoisted_2 = { class: "errorModal_inner" }
const _hoisted_3 = { class: "errorModal_ttl" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "errorModal_btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Overlay = _resolveComponent("Overlay")!

  return (_openBlock(), _createBlock(_component_Overlay, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.contents[_ctx.lang].title), 1),
          _createElementVNode("p", {
            class: "errorModal_text",
            innerHTML: _ctx.contents[_ctx.lang].text
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.$store.state.errorModal.type === 'contents')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  color: "primary",
                  shadow: "white",
                  text: _ctx.contents[_ctx.lang].btnRetry,
                  handleClick: _ctx.reload
                }, null, 8, ["text", "handleClick"]))
              : _createCommentVNode("", true),
            (_ctx.$store.state.errorModal.type === 'auth')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  color: "border",
                  shadow: "white",
                  text: _ctx.contents[_ctx.lang].btnClose,
                  handleClick: () => _ctx.$store.dispatch('closeErrorModal')
                }, null, 8, ["text", "handleClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}